/**
 * Makes tables responsive by automatically adding data-label attributes
 * from table headers for mobile list view
 */
export function makeTableResponsive(tableSelector = ".vf-crud-list") {
    const tables = document.querySelectorAll(tableSelector)

    tables.forEach(table => {
        // Add responsive-list class
        table.classList.add("responsive-list")

        // Get all header cells
        const headers = table.querySelectorAll("thead th")
        const headerTexts = Array.from(headers).map(th =>
            th.classList.contains("d-none") ? null : th.textContent?.trim(),
        )

        // Add data-label to all body cells (exclude rows with open-row class)
        const rows: NodeListOf<HTMLTableRowElement> = table.querySelectorAll("tbody tr:not(.open-row)")

        rows.forEach((row, rowIndex) => {
            const cells = row.querySelectorAll("td")

            cells.forEach((cell, index) => {
                if (headerTexts[index]) {
                    cell.setAttribute("data-label", headerTexts[index])
                }
            })

            // Add alternating background class
            if (rowIndex % 2 === 1) {
                row.dataset.even = "true"
            }
        })
    })
}
